import React, { useState, useEffect } from 'react';

import { Tab } from './tab';

export const Tabs = ({ children, active, className }) => {
  const [activeTab, setActiveTab] = useState('');

  useEffect(() => {
    setActiveTab(active);
  }, [active]);

  const onClickTabItem = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className={`tabs ${className}`}>
      <ol className="tab-list">
        {children.map((child) => {
          const label = child.props === undefined ? '' : child.props.label;
          const onClick =
            child.props === undefined ? () => {} : child.props.onClick;

          return (
            <Tab
              activeTab={activeTab}
              key={label}
              label={label}
              onClick={(e) => {
                onClickTabItem(e);
                if (onClick) {
                  onClick(e);
                }
              }}
            />
          );
        })}
      </ol>
      <div className="tab-content">
        {children.map((child) => {
          if (child.props === undefined) return null;
          if (child.props.label !== activeTab) return null;
          return child.props.children;
        })}
      </div>
    </div>
  );
};
